import React from "react";
import { Box, Typography } from "@mui/material";

function NotesTabItem({ topic, demo, courseDetails }) {
  console.log(topic, ":topicssssssssss");
  console.log(demo, ":Demoeeeeeeeeeeeeeeeee");
  const notes = [
    "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
    "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
    "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
    "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
    "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
    "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
    "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
    "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
    "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
    "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
  ];

  return demo?.length > 0 ? (
    <Box
      sx={{
        mt: "24px",
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1fr ",
        gap: "20px",
      }}
    >
      {demo.map((item, index) => (
        <Box
          key={index}
          sx={{
            cursor: "pointer",
            padding: "16px",
            borderRadius: "8px",
            display: "grid",
            gridTemplateColumns: "1fr",
            gap: "10px",
            alignItems: "center",
            boxShadow: "0px 10px 30px 0px rgba(0, 0, 0, 0.08)",
            border: "1px solid #F5F5F5",
          }}
        >
          <Box>
            <Typography
              sx={{
                fontSize: "16px",
                color: "rgba(105, 110, 114, 1)",
              }}
            >
              Lesson 1 {item.type} Demo Class
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "10px",
                mt: "10px",
              }}
            >
              <Typography
                component={"a"}
                href={item?.DemoNote}
                download
                target="_blank"
                sx={{
                  fontSize: "16px",
                  color: "rgba(20, 30, 60, 1)",
                  fontWeight: "700",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  textDecoration: "none",
                }}
              >
                <svg
                  width="16"
                  height="20"
                  viewBox="0 0 16 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 0H2C1.46957 0 0.96086 0.21071 0.58579 0.58579C0.21071 0.96086 0 1.46957 0 2V18C0 18.5304 0.21071 19.0391 0.58579 19.4142C0.96086 19.7893 1.46957 20 2 20H14C14.5304 20 15.0391 19.7893 15.4142 19.4142C15.7893 19.0391 16 18.5304 16 18V6L10 0ZM5.498 14.19C5.189 14.48 4.733 14.61 4.202 14.61C4.09904 14.6111 3.99613 14.6051 3.894 14.592V16.018H3V12.082C3.40345 12.0218 3.81112 11.9944 4.219 12C4.776 12 5.172 12.106 5.439 12.319C5.693 12.521 5.865 12.852 5.865 13.242C5.864 13.634 5.734 13.965 5.498 14.19ZM9.305 15.545C8.885 15.894 8.246 16.06 7.465 16.06C6.997 16.06 6.666 16.03 6.441 16V12.083C6.8446 12.0241 7.2521 11.9963 7.66 12C8.417 12 8.909 12.136 9.293 12.426C9.708 12.734 9.968 13.225 9.968 13.93C9.968 14.693 9.689 15.22 9.305 15.545ZM13 12.77H11.468V13.681H12.9V14.415H11.468V16.019H10.562V12.03H13V12.77ZM10 7H9V2L14 7H10Z"
                    fill="#141E3C"
                  />
                </svg>
                View Note
              </Typography>
              {/* <Typography
                component={"a"}
                sx={{
                  fontSize: "16px",
                  color: "rgba(255, 27, 111, 1)",
                  textDecoration: "none",
                }}
                href={item.DemoNote}
                download
                target="_blank"
              >
                Download{" "}
              </Typography> */}
            </Box>
          </Box>
        </Box>
      ))}

      {topic.map((item, index) => (
        <Box
          key={index}
          sx={{
            cursor: "pointer",
            padding: "16px",
            borderRadius: "8px",
            display: "grid",
            gridTemplateColumns: "1fr",
            gap: "10px",
            alignItems: "center",
            boxShadow: "0px 10px 30px 0px rgba(0, 0, 0, 0.08)",
            border: "1px solid #F5F5F5",
          }}
        >
          <Box>
            <Typography
              sx={{
                fontSize: "16px",
                color: "rgba(105, 110, 114, 1)",
              }}
            >
              Lesson {index + 2} {item.ielts_added_topic.TopicName}
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "10px",
                mt: "10px",
              }}
            >
              <Typography
                component={"a"}
                href={item.ielts_added_topic.NoteUrl}
                download
                target="_blank"
                sx={{
                  fontSize: "16px",
                  color: "rgba(20, 30, 60, 1)",
                  fontWeight: "700",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  textDecoration: "none",
                }}
              >
                <svg
                  width="16"
                  height="20"
                  viewBox="0 0 16 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 0H2C1.46957 0 0.96086 0.21071 0.58579 0.58579C0.21071 0.96086 0 1.46957 0 2V18C0 18.5304 0.21071 19.0391 0.58579 19.4142C0.96086 19.7893 1.46957 20 2 20H14C14.5304 20 15.0391 19.7893 15.4142 19.4142C15.7893 19.0391 16 18.5304 16 18V6L10 0ZM5.498 14.19C5.189 14.48 4.733 14.61 4.202 14.61C4.09904 14.6111 3.99613 14.6051 3.894 14.592V16.018H3V12.082C3.40345 12.0218 3.81112 11.9944 4.219 12C4.776 12 5.172 12.106 5.439 12.319C5.693 12.521 5.865 12.852 5.865 13.242C5.864 13.634 5.734 13.965 5.498 14.19ZM9.305 15.545C8.885 15.894 8.246 16.06 7.465 16.06C6.997 16.06 6.666 16.03 6.441 16V12.083C6.8446 12.0241 7.2521 11.9963 7.66 12C8.417 12 8.909 12.136 9.293 12.426C9.708 12.734 9.968 13.225 9.968 13.93C9.968 14.693 9.689 15.22 9.305 15.545ZM13 12.77H11.468V13.681H12.9V14.415H11.468V16.019H10.562V12.03H13V12.77ZM10 7H9V2L14 7H10Z"
                    fill="#141E3C"
                  />
                </svg>
                View Note
              </Typography>
              {/* <Typography
                sx={{
                  fontSize: "16px",
                  color: "rgba(255, 27, 111, 1)",
                  textDecoration: "none",
                }}
                component={"a"}
                href={item.ielts_added_topic.NoteUrl}
                download
                target="_blank"
              >
                Download{" "}
              </Typography> */}
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  ) : (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "500px",
      }}
    >
      <Box
        sx={{
          "& img": {
            width: "200px",
          },
        }}
      >
        <img src="/course-no-item-to-display.png" alt="no item to list image" />
        <Typography
          sx={{
            textAlign: "center",
            fontWeight: "700",
          }}
        >
          No items to display
        </Typography>
      </Box>
    </Box>
  );
}

export default NotesTabItem;
